import { LOCATION_TYPE } from '../api/enums/location-types';
import { ZONE_LOCATION_TYPES, GLOBAL_ZONE_LOCATION_TYPES, GROUND_LOCATION_TYPES, IGNORE_EVENTS_ZONES } from '../consts';

export const checkIsAirportSeaportType = (type: LOCATION_TYPE) => {
  return type === LOCATION_TYPE.AIRPORT
    || type === LOCATION_TYPE.SEAPORT;
};

export const checkIsGroundLocationType = (type: LOCATION_TYPE) => {
  return GROUND_LOCATION_TYPES.includes(type);
};

export const checkIsZoneType = (type: LOCATION_TYPE) => {
  return ZONE_LOCATION_TYPES.includes(type);
};

export const checkIsGlobalZoneType = (type: LOCATION_TYPE) => {
  return GLOBAL_ZONE_LOCATION_TYPES.includes(type);
};

export const checkIsIgnoreEventsZone = (type: LOCATION_TYPE) => {
  return IGNORE_EVENTS_ZONES.includes(type);
};

export const isAvailabilityScheduleEnabled = (type: LOCATION_TYPE) => {
  const isSafeZone = type === LOCATION_TYPE.SAFE_ZONE;
  const isSeaport = type === LOCATION_TYPE.SEAPORT;

  return checkIsGroundLocationType(type)
    || isSeaport
    || isSafeZone;
};